import { create } from "zustand";

import { UsePaginationFetchMoreProps } from "components/Table/Pagination/types";
import { SearchQueryRequestedPage } from "types/generated";

type TofuWorkspacesStore = {
  cursor: string | null;
  requestedPage: SearchQueryRequestedPage;
  onFetchItems: (props: UsePaginationFetchMoreProps) => void;
  resetPagination: () => void;
};

const useTofuWorkspacesStore = create<TofuWorkspacesStore>((set) => ({
  cursor: null,
  requestedPage: SearchQueryRequestedPage.First,
  onFetchItems: ({ cursor, requestedPage }) => set({ cursor, requestedPage }),
  resetPagination: () => set({ cursor: null, requestedPage: SearchQueryRequestedPage.First }),
}));

export default useTofuWorkspacesStore;
